import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import ActiveJobs from "./JobTab/ActiveJobs";
import CompletedJobs from "./JobTab/CompletedJobs";
import AppliedJobs from "./JobTab/AppliedJobs";
import { useDispatch, useSelector } from "react-redux";
import { getPostCounts } from "../../../../redux/posts/action";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import DeclinedJobs from "./JobTab/DeclinedJobs";
import CancelledJobs from "./JobTab/CancelledJobs";

export default function ManageJobs() {
  const { urlstate, setManageworkJobroute } = useRouteBaseStateContext();
  const [activeTab, setActiveTab] = useState("Appliedjobs");
  const dispatch = useDispatch();
  const postlistmine = useSelector(
    ({ posts: { postlistmine } }) => postlistmine,
  );
  const postcounts = useSelector(({ posts: { postcounts } }) => postcounts);
  const path = "Assets/scss/myorders.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    dispatch(getPostCounts(5));
  }, [dispatch]);

  useEffect(() => {
    if (urlstate?.manageworkjobroute) {
      setActiveTab(urlstate?.manageworkjobroute || "Appliedjobs");
    } else {
      setActiveTab("Appliedjobs");
    }
  }, [urlstate, urlstate?.manageworkjobroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setManageworkJobroute(tab);
  };

  return (
    <div className="order-section manage-job">
      <div className="tab-sec">
        <div className="order-first">
          <h2>Manage Work</h2>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab == "Appliedjobs" ? "active" : ""}`}
                onClick={() => handleTabClick("Appliedjobs")}
              >
                Applied jobs ({postcounts?.applied})
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab == "Activejobs" ? "active" : ""}`}
                onClick={() => handleTabClick("Activejobs")}
              >
                Active jobs ({postcounts?.active})
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab == "Completedjobs" ? "active" : ""}`}
                onClick={() => handleTabClick("Completedjobs")}
              >
                Completed jobs ({postcounts?.completed})
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab == "DeclinedJobs" ? "active" : ""}`}
                onClick={() => handleTabClick("DeclinedJobs")}
              >
                Declined Jobs ({postcounts?.declined})
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab == "CancelledJobs" ? "active" : ""}`}
                onClick={() => handleTabClick("CancelledJobs")}
              >
                Cancelled Jobs ({postcounts?.cancelled})
              </a>
            </li>
          </ul>
        </div>
        <div className="tab-content">
          <div
            className={`tab-pane ${activeTab == "Appliedjobs" ? "active" : ""}`}
            id="Appliedjobs"
          >
            <AppliedJobs />
          </div>
          <div
            className={`tab-pane ${activeTab == "Activejobs" ? "active" : ""}`}
            id="Activejobs"
          >
            <ActiveJobs />
          </div>
          <div
            className={`tab-pane ${activeTab == "Completedjobs" ? "active" : ""}`}
            id="Completedjobs"
          >
            <CompletedJobs />
          </div>
          <div
            className={`tab-pane ${activeTab == "DeclinedJobs" ? "active" : ""}`}
            id="DeclinedJobs"
          >
            <DeclinedJobs />
          </div>
          <div
            className={`tab-pane ${activeTab == "CancelledJobs" ? "active" : ""}`}
            id="CancelledJobs"
          >
            <CancelledJobs />
          </div>
        </div>
      </div>
    </div>
  );
}
